// Something that is not likely to occur in any UUID implementation or propertyAlias
const ID_SEPARATOR = '---';
export const toId = (propertyInfo) => {
    if ('assetId' in propertyInfo) {
        return `${propertyInfo.assetId}${ID_SEPARATOR}${propertyInfo.propertyId}`;
    }
    return propertyInfo.propertyAlias;
};
export const fromId = (dataStreamId) => {
    if (!dataStreamId.includes(ID_SEPARATOR)) {
        return { propertyAlias: dataStreamId };
    }
    const [assetId, propertyId] = dataStreamId.split(ID_SEPARATOR);
    return {
        assetId,
        propertyId,
    };
};
